import { ProjectFileUploadField } from 'src/store/state/projects';

/**
 * Re-applies labels the user edited onto a fresh parse.
 *
 * Labels are display names layered over parsed values, so an edited label
 * survives a re-parse as long as the column in that position still has the
 * same value. A column that moved or changed value keeps the parsed label.
 */
export const mergeEditedFieldLabels = (
  fields: ProjectFileUploadField[],
  editedFields: ProjectFileUploadField[] | undefined
): ProjectFileUploadField[] =>
  fields.map((field, index) => ({
    ...field,
    label:
      editedFields?.[index]?.value === field.value
        ? editedFields[index].label
        : field.label,
  }));
